import React from "react";
import "./taglineBarStyles.scss";

const TaglineBar = () => {
  return (
    <div className="tagline-bar">
      <div className="tagline-item">Trusted Advisor</div>
      <div className="tagline-item">Skilled Negotiator</div>
      <div className="tagline-item">Expert Facilitator</div>
    </div>
  );
};

export default TaglineBar;
